import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
	DEFAULT_END_PARAM,
	DEFAULT_START_PARAM,
} from "../../hooks/useWorkOrdersFilters";

/**
 * Puts the defaults in the address bar so the filters are visible and the link is shareable.
 *
 * It writes exactly the values `useWorkOrdersFilters` already resolved for an absent parameter, so
 * the query key is the same before and after this runs and the list is not requested twice.
 */
export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("start")) {
			searchParams.set("start", DEFAULT_START_PARAM);
			shouldUpdate = true;
		}

		if (!searchParams.has("end")) {
			searchParams.set("end", DEFAULT_END_PARAM);
			shouldUpdate = true;
		}

		if (!searchParams.has("status")) {
			searchParams.set("status", "O");
			shouldUpdate = true;
		}

		if (!searchParams.has("type")) {
			searchParams.set("type", "A");
			shouldUpdate = true;
		}

		if (!searchParams.has("craft")) {
			searchParams.set("craft", "A");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
